
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companions",
      function () {
        return require("private-next-pages/companions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companions"])
      });
    }
  